<template>
  <!-- ======= Hero Section ======= -->
<section id="hero" data-aos="zoom-out" data-aos-delay="100">
    <div class="container">
        <banner :list="banner_list"></banner>
    </div>

    <!-- <svg class="hero-waves" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
         viewBox="0 24 150 28 " preserveAspectRatio="none">
        <defs>
            <path id="wave-path" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"/>
        </defs>
        <g class="wave1">
            <use xlink:href="#wave-path" x="50" y="3" fill="rgba(255,255,255, .1)"/>
        </g>
        <g class="wave2">
            <use xlink:href="#wave-path" x="50" y="0" fill="rgba(255,255,255, .2)"/>
        </g>
        <g class="wave3">
            <use xlink:href="#wave-path" x="50" y="9" fill="#fff"/>
        </g>
    </svg> -->

</section>
</template>
<script>
import banner from "@/components/public/banner.vue"
export default {
    components: {
    banner
    },
    props: {},
    data(){
        return {
            banner_list:[], 
        } // 幻灯片
    },
    methods: {
        // 获取首页信息
        // get_index_info:function(){
        //     this.$get(this.$api.getHomePageInfo).then(res=>{
        //         // console.log(res.data);
        //         this.banner_list = res.data.banner;
        //         // this.banner_bottom_adv = res.data.brandList;
        //         // this.orgRecomList = res.data.orgRecomList;
        //         // this.hotRecomList = res.data.hotRecomList;
        //         // this.floorGoodsList = res.data.floorGoodsList;
        //         // this.goods_list = res.data.goods_list;
        //         // this.goods_list_left_adv = res.data.goods_list_left_adv.adv;
        //         // this.goods_list_bottom_adv = res.data.goods_list_bottom_adv.adv;
        //         // this.seckill_goods_list = res.data.seckill_goods;
        //         // this.seckill_info = res.data.seckill_info;
        //     });
        // },
    },
    created() {
        //this.get_index_info();
    },
};
</script>
<style lang="scss" scoped>

/*--------------------------------------------------------------
# Hero Section
--------------------------------------------------------------*/
#hero {
    // width: 100%;
    background: url("~@/static/img/bg/about-bg.png");
    background-size: cover;
    position: relative;
    padding: 20px 0 0 0;
    clear: both;
}

#hero:before {
    content: "";
    //background: rgba(2, 5, 161, 0.88);
    //background: rgba(1, 11, 58, 0.884);
    //background: rgba(2, 22, 110, 0.88);
    background: #014D98;
    position: absolute;
    bottom: 0;
    top: 0;
    left: 0;
    right: 0;
}
.container{
    width:100%;
    height: 650px;
}

@media (min-width: 1024px) {
    #hero {
        background-attachment: fixed;
    }
}

@media (max-width: 991px) {
    #hero {
        padding-top: 80px;
    }

}

@media (max-width: 575px) {
    #hero {
        width: 80%;
    }
}

@-webkit-keyframes up-down {
    0% {
        transform: translateY(10px);
    }

    100% {
        transform: translateY(-10px);
    }
}

@keyframes up-down {
    0% {
        transform: translateY(10px);
    }

    100% {
        transform: translateY(-10px);
    }
}

.hero-waves {
    display: block;
    margin-top: 60px;
    width: 100%;
    height: 60px;
    z-index: 5;
    position: relative;
}

.wave1 use {
    -webkit-animation: move-forever1 10s linear infinite;
    animation: move-forever1 10s linear infinite;
    -webkit-animation-delay: -2s;
    animation-delay: -2s;
}

.wave2 use {
    -webkit-animation: move-forever2 8s linear infinite;
    animation: move-forever2 8s linear infinite;
    -webkit-animation-delay: -2s;
    animation-delay: -2s;
}

.wave3 use {
    -webkit-animation: move-forever3 6s linear infinite;
    animation: move-forever3 6s linear infinite;
    -webkit-animation-delay: -2s;
    animation-delay: -2s;
}

@-webkit-keyframes move-forever1 {
    0% {
        transform: translate(85px, 0%);
    }

    100% {
        transform: translate(-90px, 0%);
    }
}

@keyframes move-forever1 {
    0% {
        transform: translate(85px, 0%);
    }

    100% {
        transform: translate(-90px, 0%);
    }
}

@-webkit-keyframes move-forever2 {
    0% {
        transform: translate(-90px, 0%);
    }

    100% {
        transform: translate(85px, 0%);
    }
}

@keyframes move-forever2 {
    0% {
        transform: translate(-90px, 0%);
    }

    100% {
        transform: translate(85px, 0%);
    }
}

@-webkit-keyframes move-forever3 {
    0% {
        transform: translate(-90px, 0%);
    }

    100% {
        transform: translate(85px, 0%);
    }
}

@keyframes move-forever3 {
    0% {
        transform: translate(-90px, 0%);
    }

    100% {
        transform: translate(85px, 0%);
    }
}
</style>